<div class="modal-header">
  <h4 class="modal-title pull-left">
    {{ 'global.register' | translate }} {{ currentParticipant.firstname }}
    {{ currentParticipant.lastname }}
  </h4>
  <button
    (click)="close()"
    aria-label="Close"
    class="close pull-right"
    type="button"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

@if (config) {
<div class="modal-body">
  <fieldset>
    <div class="row">
      <!-- LEFT CONTENT -->
      <div class="col-xl-6">
        <div class="col-xl-12">
          <div>
            <label class="col-form-label">{{
              'person.lastname' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              [placeholder]="'person.lastname' | translate"
              disabled
              [value]="currentParticipant.lastname"
            />
          </div>
          <div>
            <label class="col-form-label">{{
              'person.firstname' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              [placeholder]="'person.firstname' | translate"
              disabled
              [value]="currentParticipant.firstname"
            />
          </div>
          <div>
            <label class="col-form-label">{{
              'person.birthDate' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              [placeholder]="'person.birthDate' | translate"
              disabled
              [value]="currentParticipant.birthDate | date: 'dd.MM.yyyy'"
            />
          </div>
          <div>
            <label class="col-form-label">{{
              'person.privateAddress' | translate
            }}</label>
            <input
              class="form-control"
              type="text"
              [placeholder]="'person.privateAddress' | translate"
              disabled
              [value]="
                currentParticipant.address +
                ', ' +
                currentParticipant.zip +
                ' ' +
                currentParticipant.locality
              "
            />
          </div>
        </div>
      </div>
      <!-- RIGHT CONTENT-->
      <div class="col-xl-6">
        <div class="col-xl-12">
          <label class="col-form-label">{{
            'person.client.register.setCoursType' | translate
          }}</label>
          <select
            #coursTypeSelect
            (change)="onCoursTypeChange(coursTypeSelect.value)"
            [(ngModel)]="selectedCoursType"
            class="custom-select"
          >
            @if (selectedCoursType == null) {
            <option [ngValue]="null">{{
              'person.client.register.coursTypeDefault' | translate
            }}</option>
            } @for (coursType of coursTypes; track coursType) {
            <option [ngValue]="coursType">{{ coursType.name }}</option>
            }
          </select>
        </div>
        @if (selectedCoursType != null) {
        <div class="col-xl-12">
          <label class="col-form-label">{{
            'person.client.register.setLocation' | translate
          }}</label>
          <select
            #locationSelect
            (change)="onLocationChange(locationSelect.value)"
            [(ngModel)]="selectedLocation"
            class="custom-select"
          >
            @if (selectedLocation == null) {
            <option [ngValue]="null">{{
              'person.client.register.locationDefault' | translate
            }}</option>
            } @for (location of locations; track location) {
            <option [ngValue]="location">{{ location.name }}</option>
            }
          </select>
        </div>
        } @if (selectedCoursType != null && selectedLocation != null) {
        <div class="col-xl-12">
          <label class="col-form-label">{{
            'person.client.register.setCours' | translate
          }}</label>
          <select
            #coursSelect
            [(ngModel)]="selectedCours"
            class="custom-select"
          >
            @if (selectedCours == null) {
            <option [ngValue]="null">{{
              'person.client.register.coursDefault' | translate
            }}</option>
            } @for (cours of coursFilteredByLocation; track cours) {
            <option [ngValue]="cours"
              >N° {{ cours.number }} - {{ 'global.from' | translate }}
              {{ cours.startDate | date: 'dd.MM.yyyy' }}
              {{ 'global.at' | translate }}
              {{ cours.startDate | date: 'HH:mm' }}</option
            >
            }
          </select>
        </div>
        } @if ( selectedCoursType != null && selectedLocation != null &&
        selectedCours != null ) {
        <div class="col-xl-12">
          <label class="col-form-label">{{
            'person.client.register.setMethod' | translate
          }}</label>
          <select
            #methodSelect
            [(ngModel)]="selectedMethod"
            class="custom-select"
          >
            @for (method of PricingMethod | keyvalue; track method) {
            <option [ngValue]="method.key"
              >{{ 'global.enums.pricingMethod.' + method.key | translate }}
            </option>
            }
          </select>
        </div>
        } @if ( selectedCoursType != null && selectedLocation != null &&
        selectedCours != null && selectedMethod != null ) {
        <div class="col-xl-12">
          <label class="col-form-label">{{
            'person.client.register.setStatus' | translate
          }}</label>
          <select
            #statusSelect
            [(ngModel)]="selectedStatus"
            class="custom-select"
          >
            @for (statu of status; track statu) {
            <option [ngValue]="statu.status">{{ statu.displayedText }} </option>
            }
          </select>
        </div>
        }
      </div>
    </div>
  </fieldset>
</div>
}
<div class="modal-footer">
  <button
    class="mr-1 btn btn-labeled btn-success mb-1"
    type="button"
    [disabled]="selectedCours == null"
    (click)="saveRegistration()"
  >
    <span class="btn-label"><i class="fa fa-save"></i></span>
    {{ 'global.save' | translate }}
  </button>
  <button
    class="mr-1 mb-1 btn btn-outline-secondary"
    type="button"
    (click)="close()"
  >
    {{ 'global.close' | translate }}
  </button>
</div>
